"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDocInfo = void 0;
const getDocInfo = (doc) => {
    var _a, _b, _c, _d;
    if (!doc) {
        return null;
    }
    const data = doc.data();
    const dataCopy = Object.assign({}, data);
    return Object.assign(dataCopy, {
        id: doc.id,
        last_update_date: (_b = (_a = doc.updateTime) === null || _a === void 0 ? void 0 : _a.toMillis()) !== null && _b !== void 0 ? _b : 0,
        created_date: (_d = (_c = doc.createTime) === null || _c === void 0 ? void 0 : _c.toMillis()) !== null && _d !== void 0 ? _d : 0,
    });
};
exports.getDocInfo = getDocInfo;
//# sourceMappingURL=FirebaseNatService.js.map